export function getAromaBrowserCameraConstraints () {
  return {
    video: {
      facingMode: { ideal: 'environment' },
      width: { ideal: 640 },
      height: { ideal: 480 },
      advanced: [{ focusMode: 'continuous' }]
    }
  }
}

export function canUseAromaBarcodeDetector (BarcodeDetectorCtor) {
  return typeof BarcodeDetectorCtor === 'function'
}

export function getAromaBarcodeDetectorOptions () {
  return { formats: ['qr_code'] }
}

export function getAromaScanRegion (width, height, ratio = 0.7) {
  const sourceWidth = Math.max(1, Number(width) || 1)
  const sourceHeight = Math.max(1, Number(height) || 1)
  const cropRatio = Math.min(1, Math.max(0.2, Number(ratio) || 0.7))
  const cropWidth = Math.round(sourceWidth * cropRatio)
  const cropHeight = Math.round(sourceHeight * cropRatio)
  return {
    sx: Math.round((sourceWidth - cropWidth) / 2),
    sy: Math.round((sourceHeight - cropHeight) / 2),
    sw: cropWidth,
    sh: cropHeight
  }
}

export function getAromaQrCanvasSize (width, height, maxWidth = 480) {
  const sourceWidth = Math.max(1, Number(width) || 1)
  const sourceHeight = Math.max(1, Number(height) || 1)
  const targetWidth = Math.min(sourceWidth, Math.max(240, Number(maxWidth) || 480))
  return {
    width: Math.round(targetWidth),
    height: Math.round(targetWidth * sourceHeight / sourceWidth)
  }
}
